import OkC from "shared/util/OkcApi";

export function getBootstrapInfo(params = {}) {
	return OkC.get("/okc/user_bootstrap", { data: params });
}



// WEBPACK FOOTER //
// ./src/routers/shared/util/WebUtil.js